<template>
    <div class="bg-grey-lighter">
        <div class="w-full flex justify-center items-center">
            <div class="flex justify-center flex-col items-center py-4 md:mt-2 md:w-3/4 text-black leading-loose text-center">
                <h3 v-responsive.md.xl.lg class="px-6 text-xl">
                    {{contents.pages.home.content.block1.title}}
                </h3>
                <h3 v-responsive.sm.xs class="px-6 text-md">
                    E. Budding Installatietechniek
                </h3>
                <h3 class="text-sm font-thin md:text-lg">
                    {{contents.pages.home.content.block1.content}}
                </h3>
            </div>
        </div>
        <div class="w-full flex justify-center items-center">
            <div class="flex justify-center flex-col items-center py-4 px-4 md:my-2 md:w-3/5 text-black leading-loose text-center">
                <h3 v-responsive.md.xl.lg class="px-6 text-xl">
                    {{contents.pages.home.content.block2.title}}
                </h3>
                <h3 v-responsive.sm.xs class="px-6 text-md">
                    Over
                </h3>
                <h3 class="text-sm font-thin md:text-lg">
                    {{contents.pages.home.content.block2.content}}
                </h3>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "HomeComponent",
        props: ['contents'],
    }
</script>
